import config from "../../../config";

// FIND ORGANIZATIONS WHERE THE USER HAS ROLES
const userOrganizations = (user) => {
  return user.roles?.reduce((acc, role) => {
  if(role.organization?.id && !acc?.find(organization => organization.id === role.organization?.id)) {
    acc.push(role.organization);
  }
  if(role.organization === null && !acc?.find(organization => organization.id === null)) {
    acc.push({id: null, name: config.adminOrganization, comune: config.comuneDefault});
  }
  return acc;
}, []);
}

export default userOrganizations;


